import { Modal, Box, Typography, Button } from "@mui/material";

/**
 * Модальное окно для отображения данных ячейки таблицы.
 * @param {Object} props - Параметры компонента.
 * @param {boolean} props.open - Состояние видимости модального окна.
 * @param {Function} props.onClose - Функция для закрытия модального окна.
 * @param {Object} props.cellData - Данные ячейки для отображения.
 */
const CellModal = ({ open, onClose, cellData }) => {
  console.log("cellData: ", cellData);
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <Box sx={{
        background: 'white',
        p: 4,
        borderRadius: 2,
        width: '90%',
        maxWidth: 500,
        maxHeight: '90vh',
        overflow: 'auto',
        position: 'relative'
      }}>
        <Typography variant="h6" gutterBottom>Данные ячейки</Typography>
        
        <div style={{ marginBottom: '16px' }}>
          <Typography variant="body2" style={{ fontWeight: 'bold' }}>Значение:</Typography>
          <Typography variant="body1">{cellData?.value || 'N/A'}</Typography>
        </div>
        
        <div style={{ marginBottom: '16px' }}>
          <Typography variant="body2" style={{ fontWeight: 'bold' }}>ID колонки:</Typography>
          <Typography variant="body1">{cellData?.columnId || 'N/A'}</Typography>
        </div>
        
        <div style={{ marginBottom: '16px' }}>
          <Typography variant="body2" style={{ fontWeight: 'bold' }}>Данные строки:</Typography>
          <pre style={{ background: '#f5f5f5', padding: '8px', borderRadius: '4px', fontSize: '12px' }}>
            {JSON.stringify(cellData?.row, null, 2)}
          </pre>
        </div>
        
        <div style={{ marginBottom: '16px' }}>
          <Typography variant="body2" style={{ fontWeight: 'bold' }}>Дополнительные данные:</Typography>
          <pre style={{ background: '#f5f5f5', padding: '8px', borderRadius: '4px', fontSize: '12px' }}>
            {JSON.stringify(cellData?.extraData, null, 2)}
          </pre>
        </div>

        <Button variant="contained" onClick={onClose}>
          Закрыть
        </Button>
      </Box>
    </Modal>
  );
};

export default CellModal;